import { queryOptions, skipToken } from "@tanstack/react-query";

import { MASTER_INVALIDATION_KEY } from "@/api/queryClient";
import { getCaseTagById, getCaseTags } from "@/api/resources/caseTags/api";
import i18n from "@/providers/i18n";

const entity = i18n.t("case-tag");
const entityErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entity }),
};
const entities = i18n.t("case-tags");
const entitiesErrorMessage = {
  text: i18n.t("notify.error-reason.unexpected"),
  title: i18n.t("notify.get.error", { e: entities }),
};

export const caseTagsQueryKeys = {
  all: () => [...MASTER_INVALIDATION_KEY, "caseTags"],
  lists: () => [...caseTagsQueryKeys.all(), "list"],
  listAll: () => [...caseTagsQueryKeys.lists(), "all"],
  byId: (id?: string) => [...caseTagsQueryKeys.all(), "byId", id],
};
export const caseTagsQueries = {
  listAll: () =>
    queryOptions({
      queryKey: [...caseTagsQueryKeys.listAll()],
      queryFn: () => getCaseTags(),

      meta: {
        errorMessage: entitiesErrorMessage,
      },
    }),
  byId: (id?: string) =>
    queryOptions({
      queryKey: [...caseTagsQueryKeys.byId(id)],
      queryFn: id ? () => getCaseTagById(id) : skipToken,

      meta: {
        errorMessage: entityErrorMessage,
      },
    }),
};
